// 由 scripts/build-routes.ts 產生，不要手改。
// 來源：analysis/menu-tree.json（原系統 menu_general.jsp 解析結果）

export interface GeneratedMenuItem {
  id: string;
  label: string;
  /** 已對到 React route 的路徑；routeExists 為 false 時沒有對應頁面。 */
  href: string;
  routeExists: boolean;
  /** FC-5：三角色可見性（legacy-visible.generated.ts 的 LEGACY_MENU_ITEMS，
   * 以 (群組,功能名) 為 key）。找不到對應項時給三角色皆不可見——這個功能在三角色
   * 任何一份即時擷取的選單樹裡都沒出現過，給「皆可見」等於捏造沒發生過的畫面
   * （R2：修正 R1 遺留的註解與資料不一致，data 本來就是 []，只是註解寫錯）。 */
  visibleTo: readonly ('admin' | 'teacher' | 'student' | 'mentor')[];
}

export interface GeneratedMenuGroup {
  id: string;
  label: string;
  items: readonly GeneratedMenuItem[];
}

export const menuGroups: readonly GeneratedMenuGroup[] = [
  {
    "id": "menu-group-0",
    "label": "首頁",
    "items": [
      {
        "id": "menu-group-0-item-0",
        "label": "學員首頁",
        "href": "/main/studentMain",
        "routeExists": true,
        "visibleTo": []
      },
      {
        "id": "menu-group-0-item-1",
        "label": "教師首頁",
        "href": "/main/teacherMain",
        "routeExists": true,
        "visibleTo": [
          "mentor"
        ]
      },
      {
        "id": "menu-group-0-item-2",
        "label": "科部管理員首頁",
        "href": "/main/departmentAdminMain",
        "routeExists": true,
        "visibleTo": [
          "admin"
        ]
      },
      {
        "id": "menu-group-0-item-3",
        "label": "學員首頁",
        "href": "/main/dentisit/studentMain",
        "routeExists": true,
        "visibleTo": []
      },
      {
        "id": "menu-group-0-item-4",
        "label": "教師首頁",
        "href": "/main/dentisit/teacherMain",
        "routeExists": true,
        "visibleTo": [
          "mentor"
        ]
      },
      {
        "id": "menu-group-0-item-5",
        "label": "學員首頁",
        "href": "/main/medicalAffairs/studentMain",
        "routeExists": true,
        "visibleTo": []
      },
      {
        "id": "menu-group-0-item-6",
        "label": "教師首頁",
        "href": "/main/medicalAffairs/teacherMain",
        "routeExists": true,
        "visibleTo": [
          "mentor"
        ]
      },
      {
        "id": "menu-group-0-item-7",
        "label": "一般首頁",
        "href": "/main",
        "routeExists": true,
        "visibleTo": [
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-1",
    "label": "表單精靈",
    "items": [
      {
        "id": "menu-group-1-item-0",
        "label": "表單設計",
        "href": "/formTemplate/formTemplateList",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-1-item-1",
        "label": "師資群維護",
        "href": "/instruction/teacherPool",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-1-item-2",
        "label": "常用題型格式維護",
        "href": "/formTemplate/fieldType/fieldTypeList",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-1-item-3",
        "label": "共用表單設定",
        "href": "/formTemplate/commonFormTemplate",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-1-item-4",
        "label": "個人化等第制成績設定",
        "href": "/instruction/personalizationGPA/showVersion",
        "routeExists": true,
        "visibleTo": []
      }
    ]
  },
  {
    "id": "menu-group-2",
    "label": "訓練計畫專區",
    "items": [
      {
        "id": "menu-group-2-item-0",
        "label": "訓練計畫",
        "href": "/instruction/planTargetList",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-2-item-1",
        "label": "學習項目類別維護",
        "href": "/instruction/studyItemTypeMaintain",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-2-item-2",
        "label": "學習項目內容維護",
        "href": "/instruction/studyItemMaintain",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-2-item-3",
        "label": "訓練計畫手動補發",
        "href": "/form/extra/planFormDispatch",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-3",
    "label": "課程專區",
    "items": [
      {
        "id": "menu-group-3-item-0",
        "label": "課程部門代碼維護",
        "href": "/instruction/courseDepartmentCode/maintenance",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-3-item-1",
        "label": "課程類別維護",
        "href": "/course/courseType",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-3-item-2",
        "label": "課程樣版維護",
        "href": "/course/courseManage",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-3-item-3",
        "label": "開課管理",
        "href": "/course/clazz/class",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-3-item-4",
        "label": "課程查詢",
        "href": "/course/classQuery",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-3-item-5",
        "label": "課程表單查詢",
        "href": "/form/classFormList",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-3-item-6",
        "label": "課程表單匯出",
        "href": "/report/common/classFormExport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-3-item-7",
        "label": "e-learning系統",
        "href": "/https://elearning2.ndmctsgh.edu.tw/index/login?next=/course/",
        "routeExists": false,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-4",
    "label": "學員專區",
    "items": [
      {
        "id": "menu-group-4-item-0",
        "label": "學員管理",
        "href": "/training/permmisionManage/student",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-4-item-1",
        "label": "訓練期程",
        "href": "/training/planInst/planInstList",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-4-item-2",
        "label": "教師安排",
        "href": "/training/arrange",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-4-item-3",
        "label": "訓練計畫表單查詢",
        "href": "/form/planFormList",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-4-item-4",
        "label": "核心課程查詢",
        "href": "/customer/tsgh/coreCurriculumReport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-4-item-5",
        "label": "修課紀錄查詢",
        "href": "/customer/tsgh/courseRecordReport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-4-item-6",
        "label": "案例報告統計",
        "href": "/customer/tsgh/caseReport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-4-item-7",
        "label": "批次發送表單",
        "href": "/form/batch/planFormBatchSend",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-4-item-8",
        "label": "訓練計畫表單匯出",
        "href": "/report/common/planFormExport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-4-item-9",
        "label": "綜合表單查詢",
        "href": "/form/queryFormList",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-4-item-10",
        "label": "實習證明書",
        "href": "/tsghfunc/toClerkCertPage",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-5",
    "label": "人員管理",
    "items": [
      {
        "id": "menu-group-5-item-0",
        "label": "師資管理",
        "href": "/training/permmisionManage/teacher",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-5-item-1",
        "label": "教學團隊",
        "href": "/training/planInst/toClinicalArrange",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-5-item-2",
        "label": "主治醫師合理醫療服務量設定",
        "href": "/tsghfunc/toServiceStandardSetting",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-5-item-3",
        "label": "主治醫師合理醫療服務量評估",
        "href": "/tsghfunc/toServiceStandardFormList",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-5-item-4",
        "label": "主治醫師合理醫療服務量統計表",
        "href": "/tsghfunc/serviceStandardReport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-5-item-5",
        "label": "主治醫師合理醫療服務量設定結果報表",
        "href": "/tsghfunc/serviceStandardCfgReport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-5-item-6",
        "label": "主治醫師高風險及高技術項目設定",
        "href": "/tsghfunc/toHighRiskSetting",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-5-item-7",
        "label": "主治醫師高風險及高技術項目設定結果報表",
        "href": "/tsghfunc/toHighRiskSetReport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-5-item-8",
        "label": "主治醫師高風險及高技術之醫療行為評核",
        "href": "/tsghfunc/toHighRiskFormList",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-5-item-9",
        "label": "主治醫師高風險或高技術之醫療行為評核數量統計報表",
        "href": "/tsghfunc/highRiskReport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-5-item-10",
        "label": "主治醫師高風險或高技術之醫療行為評核通過醫師名單",
        "href": "/tsghfunc/highRiskDoctorReport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-5-item-11",
        "label": "教師滿意度調查暨優良教師推薦",
        "href": "/tsghrpt/tchSatisfactionSurveyReport/index",
        "routeExists": true,
        "visibleTo": []
      }
    ]
  },
  {
    "id": "menu-group-6",
    "label": "學習紀錄",
    "items": [
      {
        "id": "menu-group-6-item-0",
        "label": "學習紀錄填寫",
        "href": "/training/studyRecord/fill",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-6-item-1",
        "label": "學習紀錄查詢",
        "href": "/training/studyRecord/status",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-7",
    "label": "測驗中心",
    "items": [
      {
        "id": "menu-group-7-item-0",
        "label": "題庫管理",
        "href": "/exam/questionBankMain",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-7-item-1",
        "label": "試卷維護",
        "href": "/exam/exam",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-7-item-2",
        "label": "試卷派送",
        "href": "/exam/dispatchExam",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-7-item-3",
        "label": "線上測驗",
        "href": "/exam/testing",
        "routeExists": true,
        "visibleTo": [
          "student"
        ]
      },
      {
        "id": "menu-group-7-item-4",
        "label": "測驗查詢",
        "href": "/exam/testing",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-8",
    "label": "共同編輯表單專區",
    "items": [
      {
        "id": "menu-group-8-item-0",
        "label": "共同編輯表單",
        "href": "/coEditForm/formGenerator",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-8-item-1",
        "label": "共同編輯表單查詢",
        "href": "/coEditForm/queryPage",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-8-item-2",
        "label": "共同編輯表單匯出",
        "href": "/coEditForm/exportPage",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-8-item-3",
        "label": "共同編輯表單完成度統計",
        "href": "/coEditForm/report/completionStatisticsPage",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-9",
    "label": "請假專區",
    "items": [
      {
        "id": "menu-group-9-item-0",
        "label": "工作日維護",
        "href": "/leave/holiday",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-9-item-1",
        "label": "請假類別設定",
        "href": "/leave/type",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-9-item-2",
        "label": "學習年度設定作業",
        "href": "/leave/leaveAnnual",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-9-item-3",
        "label": "請假單",
        "href": "/leave/leaveForm",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-10",
    "label": "成績單",
    "items": [
      {
        "id": "menu-group-10-item-0",
        "label": "成績單",
        "href": "/training/transcript",
        "routeExists": true,
        "visibleTo": []
      }
    ]
  },
  {
    "id": "menu-group-11",
    "label": "學習歷程下載",
    "items": [
      {
        "id": "menu-group-11-item-0",
        "label": "學習歷程下載",
        "href": "/customer/tsgh/studyHistoryList",
        "routeExists": true,
        "visibleTo": []
      }
    ]
  },
  {
    "id": "menu-group-12",
    "label": "報表管理",
    "items": [
      {
        "id": "menu-group-12-item-0",
        "label": "開課明細表",
        "href": "/report/common/clazzDetailExport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-1",
        "label": "課堂出席表現",
        "href": "/report/common/clazzAttendanceExport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-2",
        "label": "表單統計",
        "href": "/form/queryFormStatic",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-3",
        "label": "開課統計",
        "href": "/course/queryCourseStatic",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-4",
        "label": "old核心技能統計(依學員)",
        "href": "/tsghrpt/coreskillreportbystudent",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-5",
        "label": "核心技能統計(依學員)",
        "href": "/tsghrpt/coreSkillSutdentReport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-6",
        "label": "old核心技能統計(依技能)",
        "href": "/tsghrpt/coreskillreportbyform",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-7",
        "label": "核心技能統計(依技能)",
        "href": "/tsghrpt/coreSkillFormReport",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-8",
        "label": "核心技能完成率統計圖表",
        "href": "/tsghrpt/coreSkillStatistic",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-9",
        "label": "主治醫師教學滿意度統計",
        "href": "/tsghfunc/toPlanForm4",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-10",
        "label": "住院醫師教學滿意度統計",
        "href": "/tsghfunc/toPlanForm5",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-11",
        "label": "課程滿意度調查統計",
        "href": "/tsghfunc/toClassForm6",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-12",
        "label": "基本課程滿意度調查統計",
        "href": "/tsghfunc/toClassForm7",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-13",
        "label": "教學門診稽核表統計",
        "href": "/tsghfunc/toPlanForm8",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-14",
        "label": "教學住診暨床邊教學統計",
        "href": "/tsghfunc/toPlanForm9",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-15",
        "label": "晨會訓練官稽核檢查表統計",
        "href": "/tsghfunc/toPlanForm10",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-16",
        "label": "登入使用狀況統計",
        "href": "/tsghfunc/toLoginLogStaticPage",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-17",
        "label": "西醫UGY_學員對科部整體滿意度問卷統計",
        "href": "/tsghrpt/ugywm/studentDeptSatisfy",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-18",
        "label": "等第制表單明細",
        "href": "/tsghrpt/gapFormReport/mainPage",
        "routeExists": true,
        "visibleTo": [
          "admin"
        ]
      },
      {
        "id": "menu-group-12-item-19",
        "label": "投票總人數",
        "href": "/tsghrpt/vote/totalVote",
        "routeExists": true,
        "visibleTo": [
          "admin"
        ]
      },
      {
        "id": "menu-group-12-item-20",
        "label": "總可被投票數",
        "href": "/tsghrpt/vote/totalVoteAnalysis",
        "routeExists": true,
        "visibleTo": [
          "admin"
        ]
      },
      {
        "id": "menu-group-12-item-21",
        "label": "課程表單完成率監測",
        "href": "/tsghrpt/ugywm/courseFormFinishrate",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-22",
        "label": "學術會議紀錄",
        "href": "/report/academicMOM/mainPage",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-12-item-23",
        "label": "西醫PGY_學員各訓練階段總成績",
        "href": "/tsghrpt/pgywm/allStudentScores",
        "routeExists": true,
        "visibleTo": [
          "admin"
        ]
      }
    ]
  },
  {
    "id": "menu-group-13",
    "label": "優良臨床教師投票專區",
    "items": [
      {
        "id": "menu-group-13-item-0",
        "label": "投票維護",
        "href": "/vote/main",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-13-item-1",
        "label": "單位主管推薦",
        "href": "/vote/deptManagerRecommend",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-14",
    "label": "留言板",
    "items": [
      {
        "id": "menu-group-14-item-0",
        "label": "留言類別管理",
        "href": "/discuss/discussType",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-14-item-1",
        "label": "留言板",
        "href": "/discuss/discussBoard",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-15",
    "label": "公告",
    "items": [
      {
        "id": "menu-group-15-item-0",
        "label": "公告",
        "href": "/announcement",
        "routeExists": true,
        "visibleTo": []
      }
    ]
  },
  {
    "id": "menu-group-16",
    "label": "個人資料管理",
    "items": [
      {
        "id": "menu-group-16-item-0",
        "label": "個人基本資料維護",
        "href": "/profile/profileMaintenance",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-16-item-1",
        "label": "常用語管理",
        "href": "/config/comment",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-17",
    "label": "系統資料管理",
    "items": [
      {
        "id": "menu-group-17-item-0",
        "label": "帳號維護",
        "href": "/config/accountV2",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-17-item-1",
        "label": "組織維護",
        "href": "/config/organization",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-17-item-2",
        "label": "部門維護",
        "href": "/config/department",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-17-item-3",
        "label": "職稱維護",
        "href": "/config/jobTitle",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-17-item-4",
        "label": "年度維護",
        "href": "/config/annual",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-17-item-5",
        "label": "地點維護",
        "href": "/config/location",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-17-item-6",
        "label": "設備維護",
        "href": "/config/device",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-17-item-7",
        "label": "角色及權限維護",
        "href": "/config/role",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-17-item-8",
        "label": "實習證明單樣板維護",
        "href": "/customer/tsgh/certTemplateCfg",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-18",
    "label": "訓練類別管理",
    "items": [
      {
        "id": "menu-group-18-item-0",
        "label": "訓練類別設定",
        "href": "/config/jobTypeMaintain",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-18-item-1",
        "label": "訓練類別部門維護",
        "href": "/config/jobTypeDepartment",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-19",
    "label": "系統管理",
    "items": [
      {
        "id": "menu-group-19-item-0",
        "label": "系統參數",
        "href": "/system/systemConfig",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-19-item-1",
        "label": "Api紀錄",
        "href": "/system/apiLog/mainPage",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-19-item-2",
        "label": "訊息通知",
        "href": "/system/messageConfig",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-19-item-3",
        "label": "紀錄下載",
        "href": "/system/systemConfig/open/download/log",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-19-item-4",
        "label": "異動紀錄",
        "href": "/system/dataChange",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-19-item-5",
        "label": "登入紀錄",
        "href": "/system/loginLog",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      },
      {
        "id": "menu-group-19-item-6",
        "label": "關於系統",
        "href": "/system/about",
        "routeExists": true,
        "visibleTo": [
          "admin",
          "teacher",
          "student",
          "mentor"
        ]
      }
    ]
  },
  {
    "id": "menu-group-20",
    "label": "",
    "items": []
  }
];
